import { render, staticRenderFns } from "./o_kassa_raskhod.vue?vue&type=template&id=0bf68208&"
import script from "./o_kassa_raskhod.vue?vue&type=script&lang=js&"
export * from "./o_kassa_raskhod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports